module.exports = __webpack_public_path__ + "img/Battle3.97a8daa1.jpg";